export const fetchWithAuth = async (url, options = {}) => {
  const response = await fetch(url, options);

  if (response.status === 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("thread_id");
    window.location.href = "/";
    return null;
  }

  return response;
};
